import { NON_WORKSPACE_ROUTES } from '@/shared/constants/routes';
import { useAppSelector } from '@/shared/hooks/useStore';
import { selectCurrentWorkspace } from '@/viewmodel/features/workspace/state/workspacesSlice';
import type { ModeToggleViewState } from '@/viewmodel/features/workspace/types';
import { useAgentNavigation, useAgentReturnRoute } from '@/viewmodel/shared/agentNavigation';
import { useLocation } from 'react-router-dom';

const SHARE_DASHBOARD_PREFIX = '/share/d/';

export function useModeToggleViewModel(): ModeToggleViewState {
  const { pathname } = useLocation();
  const currentWorkspace = useAppSelector(selectCurrentWorkspace);
  const { isAgentRoute, enterAgent, exitAgent } = useAgentNavigation();
  const returnRoute = useAgentReturnRoute();

  return {
    visible: !!currentWorkspace && !NON_WORKSPACE_ROUTES.includes(pathname),
    isAgentRoute,
    backToDashboards:
      pathname.startsWith(SHARE_DASHBOARD_PREFIX) ||
      (isAgentRoute && (returnRoute?.startsWith(SHARE_DASHBOARD_PREFIX) ?? false)),
    selectAgent: () => {
      if (!isAgentRoute) enterAgent();
    },
    selectDataStudio: () => {
      if (isAgentRoute) exitAgent();
    },
  };
}
